import { getFieldErrors, isApiError, readApiError } from '@/services/api';

const FALLBACK_MESSAGE = 'Failed to request the document. Please try again.';

export interface GenerateDocumentError {
    fieldMessage: string | null;
    message: string | null;
}

export function mapGenerateDocumentError(error: unknown): GenerateDocumentError {
    const fieldMessage = getFieldErrors(error).document_type?.[0] ?? null;
    if (fieldMessage) {
        return { fieldMessage, message: null };
    }

    const message = isApiError(error) && error.data ? readApiError(error.data).message : FALLBACK_MESSAGE;
    return { fieldMessage: null, message };
}
